// import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// TODO need to get rid of the following dependencies
import store from '@/store'
import createUndoHistoryModule, { isMutationType } from '@/store/plugins/undoHistory'
import actions, {
  SET_DEFINITION,
  ADD_ATTRIBUTE,
  REMOVE_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  UPDATE_OPERATOR,
  CLEAR_DEFINITION,
  CLEAR_SELECTION,
  GROUP,
  UNGROUP,
  MOVE_ATTRIBUTE
} from './actions'

const createModule = (namespace) => {
  let n = namespace ? `${namespace}/` : ''
  return {
    state () {
      return {
        selected: [],
        definition: {
          root: true,
          children: []
        },
        viewOnly: false,
        dragAndDrop: {
          active: false,
          draggingItem: null
        },
        lastTimeTargetWasChanged: null,
        lastAttributeCommand: null
      }
    },
    getters,
    mutations,
    actions,
    modules: {
      ...createUndoHistoryModule(store, {
        filter: isMutationType([
          n + ADD_ATTRIBUTE,
          n + REMOVE_ATTRIBUTE,
          n + UPDATE_ATTRIBUTE,
          n + UPDATE_OPERATOR,
          n + CLEAR_DEFINITION,
          n + GROUP,
          n + UNGROUP,
          n + MOVE_ATTRIBUTE
        ]),
        initialValue: [],
        reducer: state => {
          return state[namespace].targetDefinition.definition.children
        },
        restoreState: state => {
          store.dispatch(n + SET_DEFINITION, state)
          store.dispatch(n + CLEAR_SELECTION)
        }
      }, {add: true, namespace}).module
    }
  }
}

export default createModule



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/store/index.js